<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs  @tab-click="change_click">
            <!-- 集群主设置 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.colony1") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 是否启用集群主节点 -->

                                <td>{{ $t("logs.colony1_a1") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="salt_colony_master">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.colony1_a2')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- 集群主节点IP地址 -->
                                <td>{{ $t("logs.colony1_a3") }}:</td>
                                <td>
                                    <el-input v-model="salt_colony_master_ip" placeholder style="margin-bottom:0"></el-input>
                                    <el-alert :title="$t('logs.colony1_a4')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>

                            <tr></tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_colony_master()"  :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 集群从设置 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.colony2") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 是否启用集群从节点 -->

                                <td>{{ $t("logs.colony2_a1") }}:</td>

                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="salt_colony_minion">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.colony2_a2')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- 集群主节点IP地址 -->
                                <td>{{ $t("logs.colony1_a3") }}:</td>

                                <td>

                                    <el-input v-model="salt_colony_master_ip1" placeholder clearable></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 集群从节点IP地址 -->
                                <td>{{ $t("logs.colony2_a3") }}:</td>
                                <td>
                                    <el-input v-model="salt_colony_minion_ip" placeholder  clearable style="margin-bottom:0"></el-input>
                                    <el-alert :title="$t('logs.colony2_a4')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr></tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_colony_minion()"  :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- 集群列表 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.colony3") }}
                </span>
                <div class="main">
                    
                        <el-button @click="tan_min_host()"  :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.colony3_a1") }} </el-button>
                          <el-alert :title="this.show_minion_host" type="warning" show-icon :closable="false"></el-alert>
                   
                </div>
                <div class="switch1">
                    <div class="table table3">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"></el-table-column>
                            <el-table-column prop="IP" :label="$t('logs.network1_a5')" width="140"></el-table-column>
                            <el-table-column prop="TYPE" :label="$t('logs.firewall2_a3')"></el-table-column>
                            <el-table-column prop="STATUS" :label="$t('logs.colony3_a2')"></el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small"  :disabled="$root.jurisdiction.only_query==0"> {{ $t("table1.delete") }}</el-button>
                                   
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-loading="loading1" v-drag="{ handle: '.pop_up_text_import_iup' }"
            >
              <div class="pop_up_text  pop_up_text_import_iup">
                <span style="padding:0 14px"></span>{{ $t("logs.colony3_a1") }}
              </div>
              <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">{{$t('logs.manage3')}}:</div>
                                <div class="block block1">
                                    <el-select v-model="ipaddr" placeholder="请选择">
                                        <el-option v-for="item in ipaddr_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">{{$t('logs.smtpIp6')}}:</div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_minion_host()" :disabled="this.ipaddr==0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            show_minion_host:'',
            type: 'both',
            type_arr: [],
            ipaddr: 0,
            ipaddr_arr: [],
            data_loadok:'',
        data_loadok1:'',
loading:false,
loading1:false,
            salt_colony_minion_ip: '',
            salt_colony_master_ip1: '',
            salt_colony_minion: '',
            salt_colony_master_ip: '',
            salt_colony_master: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: [],
            loading_load:0,
        };
    },
    mounted() {
        this.getFileList_load_colony_master()
        // this.getFileList_load_colony_minion()
        // this.change_click()
    },
    methods: {
        change_click(index){
            console.log(index.index)
            if(index.index==2){
        this.getFileList_load_colony_minion_host()

            }else if(index.index==0){
        this.getFileList_load_colony_master()

            }else if(index.index==1){
        this.getFileList_load_colony_minion()

            }
        },
        // 显示
        tan_min_host: function () {
             let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
             this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "add_minion_host",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                      
            this.tanchu = true;
                        this.ipaddr_arr=res.data.ret.q_minion_request
                        this.ipaddr=res.data.ret.q_minion_request[0].value==0?0:res.data.ret.q_minion_request[0].value
                        
                        this.type_arr=res.data.ret.q_type
                        this.type=res.data.ret.q_type[0].value
                        // this.ipaddr_arr=res.data.ret.q_minion_request[0].value


                    }
                })
                .catch((err) => {
                    console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 集群主加载
        getFileList_load_colony_master() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_colony_master",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        this.salt_colony_master = res.data.ret.result.SYS_SALT_MASTER_ON==1?true:false
                        this.salt_colony_master_ip = res.data.ret.result.SYS_SALT_MASTER_IPADDR
                        console.log( this.salt_colony_master)
                        this.data_loadok = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
                .catch((err) => {
                    console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 集群主保存
        save_colony_master() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_colony_master",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                salt_colony_master: this.salt_colony_master==true?1:0,
                salt_colony_master_ip: this.salt_colony_master_ip,
                

                data_loadok: this.data_loadok

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList_load_colony_master();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
          // 集群从加载
        getFileList_load_colony_minion() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_colony_minion",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        this.salt_colony_minion = res.data.ret.result.SYS_SALT_MINION_ON==1?true:false
                        this.salt_colony_master_ip1 = res.data.ret.result.SYS_SALT_MASTER_IPADDR
                        this.salt_colony_minion_ip = res.data.ret.result.SYS_SALT_MINION_IPADDR
                        console.log( this.salt_colony_master)
                        this.data_loadok1= res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
                .catch((err) => {
                    console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 集群从保存
        save_colony_minion() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_colony_minion",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                       
                salt_colony_minion: this.salt_colony_minion==true?1:0,
                salt_colony_master_ip: this.salt_colony_master_ip1,
                salt_colony_minion_ip: this.salt_colony_minion_ip,
                

                data_loadok: this.data_loadok1

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList_load_colony_minion();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
           // 集群列表加载
        getFileList_load_colony_minion_host() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_minion_host",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                      this.show_minion_host=res.data.ret.LOAD_HINT
                      this.fileList=res.data.ret.datalist
                     

                    }
                })
                .catch((err) => {
                    console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
         // 集群列表删除
        handleClick(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = scope.IP;
                  
                  this.loading-true

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_minion_host",
                                sid: sid,
                               minion_host:ipaddr

                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_load_colony_minion_host()
                                this.$message({
                                    type: "success",
                                   message: `${this.$t('anti_gs1_tan.del1')}`,
                                    
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                         message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });

        },
        // 集群列表保存
        save_minion_host() {
                    // console.log(1)
                    this.loading1=true
           
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_minion_host",
                sid: sid,
                ipaddr: this.ipaddr,
                type: this.type,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
                
                                       this.loading1=false

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
 this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                        this.loading = false;
                        this.getFileList_load_colony_minion_host()
                    }
                })
              
           
        },
    }
};
</script>

<style lang="less" scoped>
// 证书管理表头
.table3 {
    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(2) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(4) {
        text-align: left;

    }

    /deep/ .has-gutter th:nth-child(5) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(2) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(5) {
        text-align: center;

    }
}

/deep/ .el-alert__content {
    padding: 0;
}

/deep/ .el-input--suffix {
    width: 300px;
}

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 1
.main {
    display: flex;
    align-items: center;
    // border: 1px solid #dcdfe6;
    // background: #eceff4;
    margin: 20px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

.el-button {
    padding: 6px;
}

.find2-1 .find-text {
    font-size: 14px;
}

.find2-1 .el-row {
    margin-left: 140px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 26px;
}

// 弹出框1

.el-input {
    // width: 20%;
    padding: 5px 10px 5px 0;
}

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
}



.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
    font-size: 12px;
}

// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
//     padding-left: 20px;
//     border-left: 0px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
//     padding-right: 20px;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";

@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
</style>
